import * as React from 'react';
import { createPortal } from 'react-dom';
import './dashboard.css';
import { connect } from 'react-redux';
import { getSession } from 'app/shared/reducers/authentication';
import { CardComp } from 'app/modules/card-comp/card-comp';
import { Container } from 'reactstrap';
import { getEntitiesByUserIsCurrentUser as getBookSubscriptions } from 'app/entities/book-subscription/book-subscription.reducer';
import { getEntities as getBooks } from 'app/entities/book/book.reducer';
import { getEntities as getSports } from 'app/entities/sport/sport.reducer';
import { IRootState } from 'app/shared/reducers';
import { TextFormat } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { IBookSubscription } from 'app/shared/model/book-subscription.model';

export interface IDashboardProp extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export interface IDashboardState {
  counter: number;
  newRow: boolean;
}

export class Dashboard extends React.Component<IDashboardProp, IDashboardState> {
  componentDidMount() {
    this.props.getBookSubscriptions();
    this.props.getBooks();
    this.props.getSports();
  }

  scrollToShelf = sportId => () => {
    const shelf = document.getElementById(`shelf-${sportId}`);
    if (shelf) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      shelf.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  };

  getBookArray = list => {
    const array = new Array();
    list.forEach((item, itemIndex) => {
      array.push(item);
    });
    return array;
  };

  getSportsArray = sportsList => {
    const titleArray = new Array();
    sportsList.forEach((sport, sportIndex) => {
      titleArray.push(sport);
    });
    return titleArray;
  };

  getBookSubscriptionMap = (sportsList, bookSubscriptionList) => {
    const subscriptionMap = new Map();
    sportsList.forEach((sport, sportIndex) => {
      const sportName = sport.name;
      subscriptionMap.set(sportName, new Array());
    });

    bookSubscriptionList.forEach((bookSubscription, bookSubscriptionIndex) => {
      const sportName = bookSubscription.book.sport.name;
      if (subscriptionMap.has(sportName)) subscriptionMap.get(sportName).push(bookSubscription);
    });
    return subscriptionMap;
  };

  getCardCompElement = bookSubscription => (
    <CardComp
      iconName={bookSubscription.book.iconName}
      bookTitle={bookSubscription.book.name}
      bookDescription={bookSubscription.book.description}
      bookId={bookSubscription.book.id}
      bookUrl={bookSubscription.book.url}
      subscriptionStatus={bookSubscription.isActive}
    />
  );

  render() {
    const { bookSubscriptionList, sportList, bookList } = this.props;
    const sportsArray = this.getSportsArray(sportList);
    const bookArray = this.getBookArray(bookList);
    const bookSubscriptionMap = this.getBookSubscriptionMap(sportList, bookSubscriptionList);

    // Sports that have books, with their merged and sorted shelf. Plain calls rather than inner
    // components, so a re-render updates the shelves instead of remounting and replaying the animation.
    const shelves = sportsArray
      .map(sport => {
        const booksBySport = bookArray.filter(book => book.sport.name === sport.name);
        const subscriptionArray = bookSubscriptionMap.get(sport.name) || [];

        // Merge unsubscribed books (FREE / PAID)
        const subscribedBookIds = subscriptionArray.map(subscription => subscription.book.id);
        booksBySport.forEach(book => {
          if (subscribedBookIds.indexOf(book.id) === -1) {
            const iBookSubscription: IBookSubscription = {
              isActive: book.isFree === true,
              book
            };
            subscriptionArray.push(iBookSubscription);
          }
        });

        // Sort: active + free first
        subscriptionArray.sort((a, b) => (a.isActive || a.book.isFree ? -1 : 1));
        return { sport, subscriptionArray };
      })
      .filter(shelf => shelf.subscriptionArray.length > 0);

    const headerSlot = document.getElementById('header-shelf-count');
    const bookCount = shelves.reduce((total, shelf) => total + shelf.subscriptionArray.length, 0);

    return (
      <div className="shop">
        <h1 className="sr-only">Betting Bookshop shelves</h1>
        {bookCount > 0 && headerSlot
          ? createPortal(
              <span>
                {bookCount} books on {shelves.length} shelves
              </span>,
              headerSlot
            )
          : null}
        <nav className="sport-nav" aria-label="Shelves">
          <div className="sport-nav-inner">
            {shelves.map(({ sport, subscriptionArray }) => (
              <button key={sport.id} type="button" onClick={this.scrollToShelf(sport.id)}>
                {sport.name}
                <span>{subscriptionArray.length}</span>
              </button>
            ))}
          </div>
        </nav>
        <Container className="dashboard-container">
          {shelves.map(({ sport, subscriptionArray }) => (
            <section key={sport.id} id={`shelf-${sport.id}`} className="sport-section">
              <h2>{sport.name}</h2>
              <div className="subscription-grid">
                {subscriptionArray.map(subscription => (
                  <div key={subscription.book.id} className="subscription-grid-item">
                    {this.getCardCompElement(subscription)}
                  </div>
                ))}
              </div>
            </section>
          ))}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ bookSubscription, sport, book }: IRootState) => ({
  bookSubscriptionList: bookSubscription.entities,
  sportList: sport.entities,
  bookList: book.entities
});

const mapDispatchToProps = {
  getSports,
  getBooks,
  getBookSubscriptions
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
